<template>
    <!-- App Sidebar -->
    <div class="modal fade panelbox panelbox-left" id="sidebarPanel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body p-0">
                    <!-- profile box -->
                    <div class="profileBox pt-2 pb-2" v-if="currentUser">
                        <div class="image-wrapper">
                            <img src="assets/icons_blue/icon-192x192.png" alt="image" class="imaged  w36"
                                v-if="profile.avatar == 'member.jpg' || profile.avatar == null">
                            <img :src="'https://guide.msoftit.com/' + profile.avatar" alt="image" class="imaged  w36"
                                v-else>
                        </div>
                        <div class="in" @click="goToUrl('home')" data-bs-dismiss="modal">
                            <strong>{{ currentUser.name }}</strong>
                            <div class="text-muted">{{ currentUser.phone }}</div>
                        </div>
                        <a href="javascript:void(0)" class="btn btn-link btn-icon sidebar-close"
                            data-bs-dismiss="modal">
                            <ion-icon name="close-outline"></ion-icon>
                        </a>
                    </div>
                    <div class="profileBox pt-2 pb-2" v-else>
                        <div class="image-wrapper">
                            <img src="assets/icons_blue/icon-192x192.png" alt="image" class="imaged  w36">
                        </div>
                        <!-- <div class="in" @click="goToUrl('user-login')" data-bs-dismiss="modal">
                            <strong>Login</strong>
                            <div class="text-muted">or Create new</div>
                        </div> -->
                        <a href="javascript:void(0)" class="btn btn-link btn-icon sidebar-close"
                            data-bs-dismiss="modal">
                            <ion-icon name="close-outline"></ion-icon>
                        </a>
                    </div>
                    <!-- * profile box -->
                    <!-- balance -->
                    <!-- <div class="sidebar-balance">
                        <div class="listview-title">Balance</div>
                        <div class="in">
                            <h1 class="amount">$ 2,562.50</h1>
                        </div>
                    </div> -->
                    <!-- * balance -->



                    <!-- menu -->
                    <div class="listview-title mt-1">{{ $t('menu') }}</div>
                    <ul class="listview flush transparent no-line image-listview">
                        <li>
                            <a href="javascript:void(0)" class="item" @click="goToUrl('/')" data-bs-dismiss="modal">
                                <div class="icon-box bg-primary">
                                    <ion-icon name="home-outline"></ion-icon>
                                </div>
                                <div class="in">
                                    {{ $t('home') }}
                                    <span class="badge badge-primary"></span>
                                </div>
                            </a>
                        </li>
                        <li v-if="!currentUser">
                            <a href="javascript:void(0)" class="item" @click="goToUrl('user-login')"
                                data-bs-dismiss="modal">
                                <div class="icon-box bg-primary">
                                    <ion-icon name="log-in-outline"></ion-icon>
                                </div>
                                <div class="in">
                                    {{ $t('login') }}
                                    <span class="badge badge-primary"></span>
                                </div>
                            </a>
                        </li>
                        <li v-if="currentUser">
                            <a href="javascript:void(0)" class="item" @click="logout()" data-bs-dismiss="modal">
                                <div class="icon-box bg-primary">
                                    <ion-icon name="log-out-outline"></ion-icon>
                                </div>
                                <div class="in">
                                    {{ $t('logout') }}
                                    <span class="badge badge-primary"></span>
                                </div>
                            </a>
                        </li>
                        <li v-if="!currentUser">
                            <a href="javascript:void(0)" class="item" @click="goToUrl('register')"
                                data-bs-dismiss="modal">
                                <div class="icon-box bg-primary">
                                    <ion-icon name="person-add-outline"></ion-icon>
                                </div>
                                <div class="in">
                                    {{ $t('create_new_account') }}
                                    <span class="badge badge-primary"></span>
                                </div>
                            </a>
                        </li>
                        <div class="listview-title mt-1">{{ $t('language') }}</div>
                        <div class="section" style="display: flex; gap: 10px; justify-content: center; margin-top: 10px;">
                            <div class="language-switcher">
                                <button
                                    class="btn-lang"
                                    :class="{ active: $i18n.locale === 'en' }"
                                    @click="changeLanguage('en')"
                                    aria-label="Switch to English"
                                >
                                    English
                                </button>
                                <button
                                    class="btn-lang"
                                    :class="{ active: $i18n.locale === 'ml' }"
                                    @click="changeLanguage('ml')"
                                    aria-label="Switch to Malayalam"
                                >
                                    Malayalam
                                </button>
                            </div>
                        </div>
                        <div class="section" style="display: flex; gap: 10px; justify-content: center; ">
                            <div class="language-switcher">
                                <button
                                    class="btn-lang"
                                    :class="{ active: $i18n.locale === 'ta' }"
                                    @click="changeLanguage('ta')"
                                    aria-label="Switch to Tamil"
                                >
                                    Tamil
                                </button>
                                <button
                                    class="btn-lang"
                                    :class="{ active: $i18n.locale === 'kn' }"
                                    @click="changeLanguage('kn')"
                                    aria-label="Switch to Kannada"
                                >
                                    Kannada
                                </button>
                            </div>
                        </div>
                        <div class="listview-title mt-1">{{ languageMessage}}</div>
                        <!-- <li>
                            <a href="app-pages.html" class="item">
                                <div class="icon-box bg-primary">
                                    <ion-icon name="document-text-outline"></ion-icon>
                                </div>
                                <div class="in">
                                    Pages
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="app-components.html" class="item">
                                <div class="icon-box bg-primary">
                                    <ion-icon name="apps-outline"></ion-icon>
                                </div>
                                <div class="in">
                                    Components
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="app-cards.html" class="item">
                                <div class="icon-box bg-primary">
                                    <ion-icon name="card-outline"></ion-icon>
                                </div>
                                <div class="in">
                                    My Cards
                                </div>
                            </a>
                        </li> -->
                    </ul>
                    <!-- * menu -->

                </div>
            </div>
        </div>
    </div>
    <!-- * App Sidebar -->
</template>
<script>
import AuthService from "../../services/auth.service";
import { setCurrentLanguage, debugI18nInstance } from "../../utils/languageUtils";

export default {
    data() {
        return {
            profile: [],
            languageMessage: ""
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    mounted() {
        if (this.currentUser) {
            this.profile = JSON.parse(localStorage.getItem('my_profile'));
        }
    },
    methods: {
        goToUrl(url) {
            this.$router.push(url);
        },
        logout() {
            AuthService.logout();
            localStorage.activeMenu = 'Home';
            location.replace('/');
        },
        changeLanguage(lang) {
            // Update both the component instance and global i18n instance
            this.$i18n.locale = lang;
            
            // Use utility to ensure the change is propagated everywhere
            setCurrentLanguage(lang);
            
            // Debug log to verify the change
            console.log('🌐 Language changed to:', lang);
            console.log('🔍 Component locale:', this.$i18n.locale);
            console.log('🔍 Global locale via utility:', this.$i18n.global?.locale);
            
            // Debug i18n instance in development
            if (process.env.NODE_ENV === 'development') {
                debugI18nInstance();
            }
            
            let msg = '';
            if (lang === 'en') {
                msg = 'Language changed to English.';
            } else if (lang === 'ml') {
                msg = 'Language changed to Malayalam.';
            } else if (lang === 'ta') {
                msg = 'Language changed to Tamil.';
            } else if (lang === 'kn') {
                msg = 'Language changed to Kannada.';
            }
            this.languageMessage = msg;
            setTimeout(() => {
                this.languageMessage = '';
            }, 3000);
        },
    },
};
</script>

<style>
.language-switcher {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    width: 100%;
}
.btn-lang {
    flex: 1 1 0;
    min-width: 0;
    background: #f3f6fb;
    color: #2355b3;
    border: 1.5px solid #2355b3;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    padding: 8px 18px;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;
    box-shadow: none;
    cursor: pointer;
    outline: none;
    text-align: center;
}
.btn-lang.active {
    background: #2355b3;
    color: #fff;
    box-shadow: 0 2px 8px rgba(35,85,179,0.10);
}
.btn-lang:focus {
    outline: 2px solid #2355b3;
}
@media (max-width: 600px) {
    .language-switcher {
        gap: 8px;
    }
    .btn-lang {
        font-size: 14px;
        padding: 8px 6px;
    }
}
/* Language Switcher Styles */
.language-switcher {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
}
.btn-lang {
    background: #f3f6fb;
    color: #2355b3;
    border: 1.5px solid #2355b3;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    padding: 8px 18px;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;
    box-shadow: none;
    cursor: pointer;
    outline: none;
}
.btn-lang.active {
    background: #2355b3;
    color: #fff;
    box-shadow: 0 2px 8px rgba(35,85,179,0.10);
}
.btn-lang:focus {
    outline: 2px solid #2355b3;
}
</style>